export default "__VITE_ASSET__fa904473__"